import { ExclamationIcon } from '@mm/icons';
import { CustomerChatIcon } from '@mm/icons/StarterIcons';
import React from 'react';
import './ActivationWarningModal.pcss';

const Header = (
  <div className="activation-warning-modal__header">
    <ExclamationIcon className="activation-warning-modal__header-icon" />
    <div className="activation-warning-modal__header-text">ALMOST THERE!</div>
  </div>
);

const Message = (
  <div className="activation-warning-modal__message">
    <CustomerChatIcon className="activation-warning-modal__message-icon" />
    <div>
      Your website chat won't be live untill you install the code on your site.
      Choose your website editor in the "Install Website Chat" section to see
      installation instructions.
    </div>
  </div>
);

export const ActivationWarningModal = {
  Header,
  Message,
  headerClassName: 'activation-warning-modal__modal-header',
};
